module.exports = __webpack_public_path__ + "img/logoActive.6940b1c9.png";